"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArc = exports.mapNumberToRange = exports.GKSpinner = void 0;
var react_1 = __importDefault(require("react"));
var common_1 = require("../../../common");
require("./GKSpinner.css");
var GKSpinner = function (props) {
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-spinner",
    }), inverse = _a.inverse, _b = _a.width, size = _b === void 0 ? 60 : _b, value = _a.value, mappedProps = __rest(_a, ["inverse", "width", "value"]);
    // Refs to our canvas, its animation context, requestAnimationFrame, and a timestamp
    var canvas = react_1.default.useRef(null);
    var ctx = react_1.default.useRef();
    var raf = react_1.default.useRef(0);
    var time = react_1.default.useRef(0);
    // Set up our drawing context and kick off our requestAnimationFrame loop.
    react_1.default.useEffect(function () {
        var _a;
        ctx.current = (_a = canvas.current) === null || _a === void 0 ? void 0 : _a.getContext("2d");
        raf.current = requestAnimationFrame(spin);
        if (ctx.current) {
            ctx.current.lineWidth = size / 6;
            ctx.current.strokeStyle = inverse ? "#fff" : "#2d64b3";
        }
        return function () { return cancelAnimationFrame(raf.current); };
        // Restart the animation if any of the important values change.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [size, inverse, value]);
    var normalizedVal = react_1.default.useMemo(function () {
        if (value === undefined) {
            return undefined;
        }
        return Math.max(0, Math.min(value, 100));
    }, [value]);
    // This is our animation loop.
    var spin = function (timestamp) {
        if (!ctx.current) {
            return;
        }
        var fps = 1000 / (timestamp - time.current);
        var arc = (0, exports.getArc)({ value: normalizedVal, timestamp: timestamp });
        ctx.current.clearRect(0, 0, size * 2, size * 2);
        // Rotate our animated spinner. Using FPS so the animation is consistent
        // regardless of the display's refresh rate.
        if (normalizedVal === undefined) {
            ctx.current.translate(size, size);
            ctx.current.rotate(Math.PI / (fps / 2.5));
            ctx.current.translate(-size, -size);
        }
        ctx.current.beginPath();
        ctx.current.arc(size, size, size - ctx.current.lineWidth / 2 - 1, arc.begin, arc.end);
        ctx.current.stroke();
        time.current = timestamp;
        requestAnimationFrame(spin);
    };
    /**
     * We double the size for width/height and then scale it back down in CSS.
     * This has the effect of doubling the DPI of the canvas from 72 to 144, which
     * looks much nicer on higher-dpi displays. We also account for this in our ctx
     * drawing methods: x/y of size is now the center of the canvas instead of the edge.
     */
    return (react_1.default.createElement("div", __assign({}, mappedProps, { role: "progressbar", "aria-valuenow": normalizedVal ? Math.round(normalizedVal) : undefined }),
        react_1.default.createElement("canvas", { ref: canvas, width: size * 2, height: size * 2, style: { width: size, height: size }, "data-qa": mappedProps["data-qa"] + "--canvas" })));
};
exports.GKSpinner = GKSpinner;
// A useful function to map a number from one range to another.
var mapNumberToRange = function (num, minA, maxA, minB, maxB) { return ((num - minA) / (maxA - minA)) * (maxB - minB) + minB; };
exports.mapNumberToRange = mapNumberToRange;
/**
 * Figure out the start/end points of our arc.
 * The end value changes based on time for indeterminate spinners, and
 * stays at one fixed point for determinate spinners.
 * This is broken out so that we can unit test it.
 */
var getArc = function (_a) {
    var value = _a.value, timestamp = _a.timestamp;
    var PI = Math.PI, cos = Math.cos;
    return {
        begin: value === undefined ? 0 : -PI / 2,
        end: value === undefined
            ? (0, exports.mapNumberToRange)(cos(timestamp / 417), -1, 1, 0.28, 6)
            : (0, exports.mapNumberToRange)(value, 0, 100, 0, PI * 2) - PI / 2,
    };
};
exports.getArc = getArc;
